export const HTML_COMPONENT_NAMESPACE = 'HTML_Settings';
export const HTML_COMPONENT_TITLE_KEY = 'HTML_Settings_Aria_Tag';
export const HTML_COMPONENT_TITLE_DEFAULT = 'Embedded Content';
